import { ReactElement } from 'react';

import { TextFieldProps as MuiTextFieldProps } from '@mui/material';
import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
} from 'react-hook-form';
import { CustomTextField } from '../custom/CustomTextField';

export type TextFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<MuiTextFieldProps, 'inputRef'> & {
  ControllerProps: Omit<ControllerProps<TFieldValues, TName>, 'render'>;
};

export const TextField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  ControllerProps,
  ...props
}: TextFieldProps<TFieldValues, TName>): ReactElement => {
  return (
    <Controller
      {...ControllerProps}
      render={({
        field: { ref, onChange, ...field },
        fieldState: { error },
      }) => (
        <CustomTextField
          {...props}
          {...field}
          inputRef={ref}
          onChange={(event) => {
            onChange(event);
            props.onChange && props.onChange(event);
          }}
          error={props.error || Boolean(error)}
          helperText={error?.message || props.helperText}
        />
      )}
    />
  );
};
